import AbstractGroupItem from '../item/abstractGroupItem';
import ContainerItem from '../item/containerItem';
import AbstractValidator from './abstractValidator';
import ValidationResult from './validationResult';

/**
 * @class CollisionValidator
 * @extends AbstractValidator
 */
export default class OutOfContainerValidator extends AbstractValidator {
    /**
     * @param {ProblemFactory} problemFactory
     * @param {OutOfContainerChecker} outOfContainerChecker
     * @param {string} message
     * @param {string} problemType
     */
    constructor(problemFactory, outOfContainerChecker, message) {
        super(problemFactory);

        this.outOfContainerChecker = outOfContainerChecker;
        this.message = message;
    }

    /**
     * @param {AbstractItem} item
     * @return {ValidationResult[]}
     */
    validateItem(item) {
        if (this._isItemSupported(item)) return super.validateItem(item);
        if (item.hasParentItem()) return this.validateItem(item.getParentItem());

        return [new ValidationResult(this)];
    }

    /**
     * Validates a single non-group item
     *
     * @param {ContainerItem} item
     * @return {AbstractProblem[]}
     * @private
     */
    _validateSingleItem(item) {
        if (!this._isItemSupported(item)) return [];

        const otherItems = item.getItems()
            .map((otherItem) => {
                if (otherItem instanceof AbstractGroupItem) return otherItem.resolveGroupItems();
                if (otherItem instanceof ContainerItem) return [otherItem].concat(otherItem.getDescendants());
                return [otherItem];
            })
            .reduce((flattened, subItems) => flattened.concat(subItems), []);

        const problems = [];
        otherItems.forEach((otherItem) => {
            if (otherItem.supportsOutOfFoam) {
                const collision = this.outOfContainerChecker.check(item, otherItem);

                if (collision) problems.push(this._createProblem(collision));
            }
        });

        return problems;
    }

    /**
     * @param {AbstractCollision} collision
     * @return {AbstractProblem}
     * @private
     */
    _createProblem(collision) {
        return this
            .problemFactory
            .createCollisionError(
                'outOfFoam',
                this.message,
                'warning-sign',
                [collision.item, collision.otherItem],
                collision,
            );
    }

    _isItemSupported(item) {
        return item instanceof ContainerItem;
    }
}
